module.exports = __webpack_public_path__ + "img/detail3.62083013.jpg";